module.exports = __webpack_public_path__ + "ab99c755c3accff34433162c16170b6c.png";